import { deliverConstants } from "../constants";


export const getDeliverLogs = ( searchKey) => {
    return {
        type: deliverConstants.GET_DELIVER_LOGS,
        searchKey,
    };
};